export default "__VITE_ASSET__DhM8weGE__"